<template>
  <portal to="modals">
    <!-- <transition name="slide-up"> -->
      <div class="image-slider-modal-overlay" @click="closeModal">
        <div class="image-slider-modal-container" @click.stop>
          <!-- Close Button -->
          <button class="modal-close-btn" @click="closeModal">
            <i class="fa fa-times"></i>
          </button>
          
          <!-- Swiper Slider -->
          <div class="image-slider-wrapper">
            <div class="swiper-container image-gallery-slider">
              <div class="swiper-wrapper">
                <div
                  v-for="(image, index) in images"
                  :key="`gallery_image_${index}`"
                  class="swiper-slide"
                >
                  <img :src="image" :alt="`Image ${index + 1}`" />
                </div>
              </div>
              
              <!-- Navigation Buttons -->
              <div class="swiper-button-prev gallery-nav-btn"></div>
              <div class="swiper-button-next gallery-nav-btn"></div>
              <div class="swiper-pagination slide-counter">
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </transition> -->
  </portal>
</template>

<script>
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';

export default {
  name: 'ImageSliderModal',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      swiperInstance: null,
      currentSlideIndex: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwiper();
    });
  },
  methods: {
    initializeSwiper() {
      if (this.swiperInstance) {
        this.destroySwiper();
      }
      
      const sliderElement = document.querySelector('.image-gallery-slider');
      if (sliderElement && this.images.length > 0) {
        this.swiperInstance = new Swiper('.image-gallery-slider', {
          modules: [Navigation, Pagination],
          slidesPerView: 1,
          initialSlide: this.initialIndex,
          pagination: {
            el: ".image-gallery-slider .swiper-pagination",
            type: "fraction",
          },
          loop: true,
          navigation: {
            nextEl: '.image-gallery-slider .swiper-button-next',
            prevEl: '.image-gallery-slider .swiper-button-prev',
          },
          on: {
            slideChange: (swiper) => {
              this.currentSlideIndex = swiper.activeIndex;
            }
          },
          touchRatio: 1
        });
        
        this.currentSlideIndex = this.initialIndex;
      }
    },
    destroySwiper() {
      if (this.swiperInstance && this.swiperInstance.destroy) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    },
    closeModal() {
      this.$emit('close');
    }
  },
  beforeDestroy() {
    this.destroySwiper();
  }
};
</script>

<style scoped lang="scss">
// Slide-up transition
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter {
  .image-slider-modal-container {
    transform: translateY(100%);
  }
}

.slide-up-enter-to {
  .image-slider-modal-container {
    transform: translateY(0);
  }
}

.slide-up-leave {
  .image-slider-modal-container {
    transform: translateY(0);
  }
}

.slide-up-leave-to {
  .image-slider-modal-container {
    transform: translateY(100%);
  }
}

.image-slider-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-slider-modal-container {
  width: 100%;
  height: 100%;
  background: white;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  transition: all 0.3s ease;
  
  i {
    color: white;
    font-size: 20px;
  }
  
  &:hover {
    background: rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
  }
}

.slide-counter {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, .5);
  color: #fff;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 600;
  z-index: 100;
  width: fit-content;
  height: fit-content;
}

.image-slider-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-gallery-slider {
  width: 100%;
  height: 100%;
  
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      display: block;
    }
  }
  
  .swiper-button-prev,
  .swiper-button-next {
    width: 50px !important;
    height: 50px !important;
    background: rgba(0, 0, 0, 0.5) !important;
    border-radius: 50%;
    color: white;
    transition: all 0.3s ease;
    
    &:after {
      font-size: 20px;
      color: white;
      font-weight: bold;
    }
    
    &:hover {
      background: rgba(0, 0, 0, 0.7) !important;
      transform: scale(1.1);
    }
  }
  
  .swiper-button-prev {
    left: 10px !important;
  }
  
  .swiper-button-next {
    right: 10px !important;
  }
}

// Mobile responsiveness
@media (max-width: 768px) {
  .modal-close-btn {
    top: 10px;
    right: 10px;
    width: 35px;
    height: 35px;
    
    i {
      font-size: 18px;
    }
  }
  
  .slide-counter {
    top: 10px;
    font-size: 14px;
    padding: 6px 12px;
  }
  
  .image-gallery-slider {
    .swiper-button-prev,
    .swiper-button-next {
      width: 40px !important;
      height: 40px !important;
      
      &:after {
        font-size: 16px;
      }
    }
  }
}

.swiper-pagination {
  color: #fff;
}
</style>